module.exports = __webpack_public_path__ + "static/media/logo-awards-white.8839fedf.8839fedf.png";